import React, { Component } from 'react';
import { Tabs, Tab } from "react-bootstrap";

import Paices from "./EstadosContent/Paices";
import Estados from "./EstadosContent/Estados";
import Ciudades from "./EstadosContent/Ciudades";
import Municipios from './EstadosContent/Municipios';
import Parroquias from './EstadosContent/Parroquias';


class Entidades extends Component {
    state = {
        key: 'paises',
        control: false,
        paices:[]
    }

    componentDidMount = () => {
        this.setState({paices: this.props.paices})
        /* ConsultaPaices ((resp) => {
            this.setState({paices: resp})
        }) */
    }

    render() {
        let { control, paices } = this.state;
        return (
            <Tabs
                id="entidades"
                activeKey={this.state.key}
                onSelect={key => this.setState({ key })}
            >
                <Tab eventKey="paises" title="Paises">
                    <Paices paises = {paices}/>
                </Tab>
                <Tab eventKey="estado" title="Estados" onClick={ () => { this.setState({ control:!control }) } }>
                    <Estados control= {control} paises = {paices}/>
                </Tab>
                <Tab eventKey="ciudades" title="Ciudades" onClick={ () => { this.setState({ control:!control }) } }>
                    <Ciudades control= {control} paises = {paices}/>
                </Tab>
                <Tab eventKey="municipios" title="Municipios" onClick={ () => { this.setState({ control:!control }) } }>
                    <Municipios control= {control} paises = {paices}/>
                </Tab>
                <Tab eventKey="parroquias" title="Parroquias" onClick={ () => { this.setState({ control:!control }) } }>
                    <Parroquias control= {control} paises = {paices}/>
                </Tab>
            </Tabs>
        );
    }
}
 
export default Entidades;


// WEBPACK FOOTER //
// ./src/views/Registros/Entidades.jsx